import React from "react";
import { Typography, Container, Paper, Grid } from "@mui/material";

const AboutPage = () => {
  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        justifyContent: "center",
        marginTop: 1,
        marginBottom: 5,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper sx={{ p: 3, borderRadius: 1 }}>
            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
              Policy Monitoring Tool
            </Typography>
            <Typography variant="body1">
              The Policy Monitoring tool provides policy makers with a visual
              policy monitoring dashboard, allowing the generation of analytical
              reports based on queries, including summary tables as well as
              graphical charts. Our goal is to support policy effectiveness by
              providing monitoring insights and evidence-based analysis on
              selected environmental, social and economic indicators at regional
              level.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper sx={{ p: 3, borderRadius: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
              Methodology
            </Typography>
            <Typography variant="body1">
              The tool integrates and renders on a regional (LAU or Commune)
              level data derived from anonymized and aggregated in-situ
              information from 10 selected Quantifarm test cases. This includes
              information from real parcels utilizing Digital Agriculture
              Technologies (DATs), parcels not employing DATs, farm calendar
              exports, and digital logs. EO data products (e.g. crop type,
              <a
                href={"https://worldcover2021.esa.int/download"}
                target="_blank"
                rel="noopener noreferrer"
              >
                ESA
              </a>
              {" "} land use), open European GIS datasets (e.g.{" "}
              <a
                href={"https://ec.europa.eu/eurostat/web/gisco/geodata/reference-data/administrative-units-statistical-units/lau"}
                target="_blank"
                rel="noopener noreferrer"
              >
                Gisco
              </a>
              ,{" "}
              <a
                href={"https://www.eea.europa.eu/en/datahub/datahubitem-view/6fc8ad2d-195d-40f4-bdec-576e7d1268e4"}
                target="_blank"
                rel="noopener noreferrer"
              >
                EEA
              </a>
              ) and open data from EU policy monitoring services (e.g.{" "}
              <a
                href={
                  "https://agriculture.ec.europa.eu/data-and-analysis/farm-structures-and-economics/fadn_en"
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                FADN
              </a>
              , ) and open data from EU policy monitoring services (e.g.{" "}
              <a
                href={"https://ec.europa.eu/eurostat/web/gisco"}
                target="_blank"
                rel="noopener noreferrer"
              >
                Eurostat
              </a>
              ) have been used as inputs to calculate indicators (KPIs),
              variables or setting thresholds for subjective qualitative and
              quantitative comparisons of regional performance related to
              policy.
              <br />
              Data privacy and confidentiality are ensured through the
              {" tool's"} process of anonymizing and aggregating data from the
              <span>
                {" "}
                <a
                  href={"https://quantifarmtoolkit.eu/results.html"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Quantifarm Test Cases
                </a>
              </span>{" "}
              during data handling.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AboutPage;
